import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {InlineUserDashboardTab} from "./InlineUserDashboardTab";
import {Messages} from "../../../../Messages";
import {InlineUserDashboardSection} from "../components/InlineUserDashboardSection";
import {InlineUserDashboardPaymentsTable} from "../components/InlineUserDashboardPaymentsTable";
import {PaymentStore} from "../../../../../client/state/PaymentStore";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {MerchantButton} from "../../../../common/MerchantButton";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {startDonationFlow} from "../../../flows/FlowEntrypoint.js";


@autoredraw(PaymentMethodStore)
export class InlineUserDashboardDonationTab extends InlineUserDashboardTab {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.donations,
        };
    }

    renderDonation() {
        const {styleSheet} = this;
        const donation = iFrameUserDataService.getActiveRecurringDonation();

        if (!donation) {
            return [
                <InlineUserDashboardSection titleMessage={Messages.donation}>
                    <MessageElement className={styleSheet.textSection}
                                    message={Messages.notRecurringDonorToMerchant(iFrameMerchantService.getMerchant().name)}/>
                    <MerchantButton label={Messages.donate} className={styleSheet.button}
                                    onClick={() => startDonationFlow()}/>
                </InlineUserDashboardSection>,
            ];
        }

        return [
            <InlineUserDashboardSection titleMessage={Messages.recurringDonation} actionMessage={Messages.edit}
                                        actionFunction={() => startDonationFlow(true)}>
                <MessageElement className={styleSheet.textSection}
                                message={Messages.recurringDonorContributing(donation.formatPrice())}/>
            </InlineUserDashboardSection>,
            iFrameMerchantService.getDonationOffer().getFrequencyOptions().find(frequency => frequency.isOneTime()) &&
                <InlineUserDashboardSection titleMessage={Messages.makeAnotherDonationTitle}>
                    <div className={styleSheet.textSection}>{Messages.makeAnotherDonationText}</div>
                    <MerchantButton label={Messages.donate} className={styleSheet.button}
                                    onClick={() => startDonationFlow(false, true)}/>
                </InlineUserDashboardSection>,
        ];
    }

    renderPaymentHistory() {
        return <InlineUserDashboardSection titleMessage={Messages.pastDonations}>
            <InlineUserDashboardPaymentsTable resourceType={PaymentStore.ResourceType.DONATION}/>
        </InlineUserDashboardSection>;
    }

    render() {
        return [
            this.renderDonation(),
            this.renderPaymentHistory(),
        ];
    }
}
